import React, { useEffect } from 'react'
import { DrawerCP } from 'submodules/nerit-framework-ui/common/components/drawer/DrawerCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { QAQCRequests } from 'submodules/nerit-aquatec-sdk/services/qaqc/QAQCRequests'
import { QAQCItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCItemResponseDTO'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'
import { DrawerQAQCIonicBalanceCP } from 'modules/reports/screens/screen-charts/content/qaqc/DrawerQAQCIonicBalanceCP'
import { DrawerQAQCAnomalyEvaluationCP } from 'modules/reports/screens/screen-charts/content/qaqc/DrawerQAQCAnomalyEvaluationCP'
import { ThemeProject } from 'config/theme/project/ThemeProject'

const EXECUTION_TYPE_LABELS: Record<QAQCExecutionTypeEnum, string> = {
	[QAQCExecutionTypeEnum.IONIC_BALANCE]: 'Balanço iônico',
	[QAQCExecutionTypeEnum.ANOMALY_EVALUATION]: 'Avaliação de anomalias',
}

interface ICPProps {
	executionCode: number
	visible: boolean
	onClose: () => void
	title?: string
}

/**
 * Drawer full-width com resultado da execução QAQC (get).
 */
export function DrawerQAQCResultCP(props: ICPProps): JSX.Element {

	const resultRequest = useRequest<QAQCItemResponseDTO>()

	useEffect(loadExecutionResult, [props.visible, props.executionCode])
	useEffect(onResultRequestDone, [resultRequest.isAwaiting, props.visible])

	function loadExecutionResult(): void {
		if (!props.visible || !props.executionCode) return
		resultRequest.runRequest(QAQCRequests.get(props.executionCode))
	}

	function onResultRequestDone(): void {
		if (!props.visible || !resultRequest.wasTried || resultRequest.isAwaiting) return
		RequestUtils.isValidRequestReturn(resultRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)
	}

	const dto = resultRequest.responseData
	const executionId = dto?.identification ?? props.title ?? String(props.executionCode)
	const drawerTitle = `Dashboard - ${executionId}`

	return (
		<DrawerCP
			title={drawerTitle}
			visible={props.visible}
			onClose={props.onClose}
			width={'100%'}
			loading={resultRequest.isAwaiting}
			noBodyPadding={true}
			bodyBackgroundColor={ThemeProject.backgroundMain}
		>
			{renderDrawerContent(props.executionCode, dto)}
		</DrawerCP>
	)
}

function renderDrawerContent(executionCode: number, dto?: QAQCItemResponseDTO): JSX.Element {
	switch (dto?.type) {
		case QAQCExecutionTypeEnum.IONIC_BALANCE:
			return <DrawerQAQCIonicBalanceCP dto={dto} />
		case QAQCExecutionTypeEnum.ANOMALY_EVALUATION:
			return <DrawerQAQCAnomalyEvaluationCP dto={dto} />
	}

	return (
		<>
			<TextCP text={'Código'} strong={true} marginBottom={4} />
			<TextCP text={String(executionCode)} marginBottom={16} />
			{!!dto?.type && (
				<>
					<TextCP text={'Tipo de execução'} strong={true} marginBottom={4} />
					<TextCP text={EXECUTION_TYPE_LABELS[dto.type] ?? String(dto.type)} />
				</>
			)}
		</>
	)
}
